export default __webpack_public_path__ + "static/media/peep-44.ed06c8b1.svg";